import { useDispatch, useSelector, useStore } from 'react-redux'
import { type FormRootState, type FormDispatch, FormStore } from './formStore'

// https://redux.js.org/usage/usage-with-typescript
// "Since these are actual variables, not types, it's important to define them
// in a separate file such as app/hooks.ts, not the store setup file. This
// allows you to import them into any component file that needs to use the
// hooks, and avoids potential circular import dependency issues."

export const useFormDispatch = useDispatch.withTypes<FormDispatch>()
export const useFormSelector = useSelector.withTypes<FormRootState>()
export const useFormStore = useStore.withTypes<FormStore>()
